export default __webpack_public_path__ + "static/media/artsBg.638461ab.png";